export const colorTokens = {
  light: {
    background: '#f6f3ee',
    paper: '#fffdf8',
    heroFrom: '#27221c',
    heroTo: '#54463a',
    textPrimary: '#211b16',
    textSecondary: '#6b5f55',
    accent: '#cf6d4b',
    border: '#ddd2c5',
  },
  dark: {
    background: '#171410',
    paper: '#221e19',
    heroFrom: '#14110e',
    heroTo: '#2d261f',
    textPrimary: '#f8f1e8',
    textSecondary: '#c3b4a4',
    accent: '#db8b63',
    border: '#3d342c',
  },
};

export const spacing = {
  sectionY: 48,
  sectionYMobile: 32,
};
